import imgLoad from "@/components/imgLoad";
import imgloadCollection from "@/components/imgLoadCollection";
import imgsUpload from "@/components/imgsUpload";
import baseUpload from "@/components/baseUpload";
// import globalUploader from '@/components/globalUploader
import cropper from "@/components/cropper";

export default (Vue) => {
  Vue.component("ImgLoad", imgLoad);
  Vue.component("ImgLoadCollection", imgloadCollection);
  Vue.component("ImgsUpload", imgsUpload);
  Vue.component("BaseUpload", baseUpload);
  Vue.component("Cropper", cropper);
  // Vue.component('GlobalUploader', globalUploader)
};
